import { create } from "zustand";

type Severity = "success" | "error" | "info" | "warning";

export interface Toast {
  id: string;
  message: string;
  severity: Severity;
}

interface ToastState {
  toasts: readonly Toast[];
  show: (toast: Omit<Toast, "id">) => void;
  dismiss: (id: string) => void;
}

const AUTO_DISMISS_MS = 4000;

export const useToastStore = create<ToastState>()((set, get) => ({
  toasts: [],
  show: (toast): void => {
    const id = crypto.randomUUID();
    const next: Toast = { id, message: toast.message, severity: toast.severity };
    set((state) => ({ toasts: [...state.toasts, next] }));
    setTimeout(() => {
      get().dismiss(id);
    }, AUTO_DISMISS_MS);
  },
  dismiss: (id): void => {
    set((state) => ({ toasts: state.toasts.filter((t) => t.id !== id) }));
  },
}));
